import { render, staticRenderFns } from "./NF1.vue?vue&type=template&id=48638888&scoped=true"
import script from "./NF1.vue?vue&type=script&lang=js"
export * from "./NF1.vue?vue&type=script&lang=js"
import style0 from "./NF1.vue?vue&type=style&index=0&id=48638888&prod&lang=scss&scoped=true"
import style1 from "./NF1.vue?vue&type=style&index=1&id=48638888&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48638888",
  null
  
)

export default component.exports